export default __webpack_public_path__ + "static/media/logo-metamask-new.d56e1501.png";